"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { ChevronDown } from "lucide-react";
import { cn } from "@/utilities/core/cn";
import { CompetitionItem } from "./CompetitionItem";
import { getCountryFlagUrl } from "./utils";
import type { CountryCompetitions } from "../types";
interface CountryAccordionItemProps {
  group: CountryCompetitions;
  isExpanded: boolean;
  onToggle: () => void;
  buildHref: (id: string) => string;
}
export function CountryAccordionItem(t0) {
  const $ = _c(26);
  const {
    group,
    isExpanded,
    onToggle,
    buildHref
  } = t0;
  let t1;
  if ($[0] !== group.country) {
    t1 = getCountryFlagUrl(group.country);
    $[0] = group.country;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const flagUrl = t1;
  let t2;
  if ($[2] !== flagUrl || $[3] !== group.country.name) {
    t2 = flagUrl && <Image src={flagUrl} alt={group.country.name} width={20} height={15} className="rounded-sm object-cover" />;
    $[2] = flagUrl;
    $[3] = group.country.name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== group.competitions.length) {
    t3 = <span className="text-xs text-muted-foreground">({group.competitions.length})</span>;
    $[5] = group.competitions.length;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== group.country.name || $[8] !== t2 || $[9] !== t3) {
    t4 = <span className="flex items-center gap-2 font-medium text-sm">{t2}{group.country.name}{t3}</span>;
    $[7] = group.country.name;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = isExpanded && "rotate-180";
  let t6;
  if ($[11] !== t5) {
    t6 = cn("h-4 w-4 text-muted-foreground transition-transform", t5);
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <ChevronDown className={t6} />;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== onToggle || $[16] !== t4 || $[17] !== t7) {
    t8 = <button onClick={onToggle} className="w-full flex items-center justify-between px-4 py-3 bg-card hover:bg-muted/50 transition-colors cursor-pointer">{t4}{t7}</button>;
    $[15] = onToggle;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== buildHref || $[20] !== group.competitions || $[21] !== isExpanded) {
    t9 = isExpanded && <div className="border-t border-border px-4 py-4"><div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-2">{group.competitions.map(competition => <CompetitionItem key={competition.id} competition={competition} href={buildHref(competition.id)} />)}</div></div>;
    $[19] = buildHref;
    $[20] = group.competitions;
    $[21] = isExpanded;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t8 || $[24] !== t9) {
    t10 = <div className="border border-border rounded-lg overflow-hidden">{t8}{t9}</div>;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}